var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBorderRadius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1337.000000, -731.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content-options",
    transform: "translate(653.000000, 665.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(65.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(490.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-border-radius",
    transform: "translate(129.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 3.11111111,
    y: 0,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 3.11111111,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 6.22222222,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 9.33333333,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 12.4444444,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 3.11111111,
    y: 12.4444444,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 6.22222222,
    y: 12.4444444,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 9.33333333,
    y: 12.4444444,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 12.4444444,
    y: 12.4444444,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 12.4444444,
    y: 9.33333333,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22222222,0.777777778 L7.77777778,0.777777778 C10.7846667,0.777777778 13.2222222,3.21533333 13.2222222,6.22222222 L13.2222222,7.77777778",
    id: "Path",
    stroke: "#1495CD",
    strokeWidth: 1.55555556
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBorderRadius);
export default __webpack_public_path__ + "static/media/icon-border-radius.7ab6e163b654bde208f465baa769e781.svg";
export { ForwardRef as ReactComponent };